import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { EMAIL_ADDRESS } from '../../../constants/site';

const READY_TO_START_BULLETS = ['Free consultation', 'No obligation', 'Expert market insights'];

const InfoCard = ({ icon: Icon, title, children }) => (
  <div className="flex items-start space-x-4 p-6 bg-gradient-to-br from-sand-100 to-neutral-50 rounded-xl border border-neutral-200">
    <div className="w-12 h-12 bg-neutral-800 rounded-lg flex items-center justify-center flex-shrink-0"><Icon className="w-6 h-6 text-white" /></div>
    <div><h3 className="font-semibold text-neutral-900 mb-1">{title}</h3>{children}</div>
  </div>
);

export const ContactInfo = () => (
  <div className="space-y-8">
    <div className="space-y-6">
      <InfoCard icon={Phone} title="Phone">
        <a href="tel:252-564-5612" className="text-neutral-600 hover:text-neutral-900 transition-colors">252-564-5612</a>
        <p className="text-sm text-neutral-500 mt-1">Available 7 days a week</p>
      </InfoCard>
      <InfoCard icon={Mail} title="Email">
        <a href={`mailto:${EMAIL_ADDRESS}`} className="text-neutral-600 hover:text-neutral-900 transition-colors break-all">{EMAIL_ADDRESS}</a>
        <p className="text-sm text-neutral-500 mt-1">I'll respond within 24 hours</p>
      </InfoCard>
      <InfoCard icon={MapPin} title="Service Areas">
        <p className="text-neutral-600">Coastal Virginia & North Carolina</p>
        <p className="text-sm text-neutral-500 mt-1">Outer Banks, Virginia Beach & surrounding areas</p>
      </InfoCard>
    </div>
    <div className="bg-neutral-900 rounded-2xl p-8 text-white">
      <h3 className="text-2xl font-serif mb-4">Ready to Get Started?</h3>
      <p className="text-neutral-300 mb-6">Whether you're buying your first home, upgrading to your dream property, or selling your current house, I'm here to guide you through every step.</p>
      <div className="space-y-2">
        {READY_TO_START_BULLETS.map((item) => (
          <div key={item} className="flex items-center space-x-2"><div className="w-2 h-2 bg-sand-50 rounded-full"></div><span className="text-sm">{item}</span></div>
        ))}
      </div>
    </div>
  </div>
);
